export default {
      id: "payment-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#payment",
      toString: function () {
        return this.url;
      }
    }